var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',[_c('el-dialog',{staticClass:"ele-dialog",attrs:{"title":_vm.title,"visible":_vm.value,"close-on-click-dialog":false,"width":_vm.dialogWidth,"center":""},on:{"close":_vm.close}},[_vm._t("dialog-body",[_c(_vm.component,_vm._g({ref:"mt-add",tag:"component",attrs:{"extra":_vm.extra}},_vm.$listeners))])],2)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce85c734","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mt/MtWindow/index.vue
// module id = null
// module chunks = 